/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Tournament_Your_TableInputs */



/**
* | output |
* | --- |
* | "Your Table ({label})" |
*
* @param {Tournament_Your_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_your_table = /** @type {((inputs: Tournament_Your_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Your_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Votre table (${i?.label})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Su mesa (${i?.label})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Sua Mesa (${i?.label})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il Tuo Tavolo (${i?.label})`)
	return /** @type {LocalizedString} */ (`Your Table (${i?.label})`)
});